export default {
    title: "我的訂單列表",
    title2: "我的支付狀態",
    tabs1: "全部訂單",
    tabs2: "未審批",
    tabs3: "已審批",
    tabs4: "全單取消",
    tabs5: "申請修改",
    tabs6: "已確認收貨",
    tabs7: "已付款",
    tabs8: "未付款",
    tabs9: "申請退貨",
    tabs10: "待支付",
    tabs11: "逾期",
    tabs12: "已全數支付",
    tabs13: "已部分支付",
    table1: "訂單號",
    table2: "日期",
    table3: "金額",
    table4: "操作用戶",
    table5: "部門",
    table6: "狀態",
    filter1: "未審批",
    filter2: "已審批",
    filter3: "申請修改",
    filter4: "取消訂單",
    filter5: "無需審批",
    filter6: "未付款",
    filter7: "已付款",
    filter8: "已確認收貨",
    filter9: "已發貨",
    filter10: "已退貨",
    filter11: "全單取消",
    filter12: "要求退貨",
    filter13: "已退貨",
    filter23: "未通過",
    diatitle: "訂單信息",
    info1: "訂單號：",
    info2: "訂單狀態：",
    info3: "審核狀態：",
    info4: "可申請修改",
    info5: "可修改內容",
    info6: "簽收圖片：",
    info7: "用戶名：",
    info8: "下單時間：",
    info9: "處理說明：",
    info10: "PDF底單：",
    info11: "流程說明：",
    info12: "收貨地址：",
    info13: "客戶備註：",
	info14: "客戶姓名：",
	info15: "電話：",
	info16: "部門：",
    nothing1: "暫無",
    nothing2: "無",
    filter14: "未確認",
    filter15: "待付款",
    filter16: "已付款",
    filter17: "已確認收貨",
    filter18: "已發貨",
    filter19: "已退貨",
    filter20: "全單取消",
    filter21: "要求退貨",
    filter22: "已退貨",
    filter23: "待付款",
    filter24: "逾期",
    filter25: "已全數支付",
    filter26: "已部分支付",
    examine1: "通過審核",
    examine2: "不通過",
    examine3: "同意申請",
    examine4: "不同意",
    table8: "商品名稱",
    table9: "單價",
    table10: "數量",
    table11: "備註",
    table12: "單位",
    table13: "合計",
    table14: "操作",
    submitBtn1: "提交此備註",
    total1: "共",
    total2: "件商品",
    total3: "合計：",
    total4: "折後價格：",
    submitBtn2: "提交審核狀態",
    submitBtn3: "提交訂單",
    submitBtn4: "申請修改",
    return1: "退貨說明：",
    return2: "申請退貨",
    succmsg1: "提交申請成功，請耐心等待！",
    succmsg2: "提交成功！",
    errmsg1: "您沒有權限查看訂單狀態頁！",
    warnmsg1: "是否刪除此訂單？",
    download: "下載"
}